import React from "react"
import PropTypes from "prop-types"
import Dialog from "@components/Dialog/Dialog"
import { getAssetPath } from "@commonUtils"
import css from "./ConfirmDialog.scss"
function ConfirmDialog(props) {
    const {
        closeButton,
        closeAction,
        heading,
        isDialogBoxOpen,
        children,
        addTopHeight,
        shouldAddChildPadding,
    } = props
    return (
        <Dialog
            isOpen={isDialogBoxOpen}
            onOverlayClick={closeAction}
            onCloseClick={closeAction}
            addTopHeight={addTopHeight}
            shouldAddChildPadding={shouldAddChildPadding}
        >
            <div
                style={{
                    width: "fit-content",
                    padding: props.padded && "8px 8px 32px 8px",
                    overflow: "auto",
                    position: "relative",
                }}
            >
                <div
                    className={`flex justifyBetween alignCenter`}
                    style={{ padding: !props.padded && "32px 32px 0 32px" }}
                >
                    {heading && <div className={`l2SemiBold`}> {heading}</div>}
                    {closeButton && (
                        <img
                            className={css.close}
                            src={getAssetPath("svgs/icons/cross_24px_primary.svg")}
                            alt={"Close popup"}
                            onClick={closeAction}
                        />
                    )}
                </div>
                {children}
            </div>
        </Dialog>
    )
}

ConfirmDialog.propTypes = {
    closeButton: PropTypes.bool,
    closeAction: PropTypes.func,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    infoIcon: PropTypes.bool,
    infoIconAction: PropTypes.func,
    primaryCtaLabel: PropTypes.string,
    primaryAction: PropTypes.func,
    secondaryCtaLabel: PropTypes.string,
    secondaryAction: PropTypes.func,
    imageUrl: PropTypes.string,
    imageDimensions: PropTypes.objectOf(
        PropTypes.shape({
            height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ),
    isDialogBoxOpen: PropTypes.bool,
    redirectionUrl: PropTypes.string,
    isExternal: PropTypes.bool,
    padded: PropTypes.bool,
    addTopHeight: PropTypes.bool,
    shouldAddChildPadding: PropTypes.bool,
}

ConfirmDialog.defaultProps = {
    isDialogBoxOpen: true,
    primaryCtaLabel: "Yes",
    secondaryCtaLabel: "No",
    imageDimensions: {
        height: "auto",
        width: "auto",
    },
    padded: true,
    addTopHeight: true,
    shouldAddChildPadding: true,
}
export default ConfirmDialog
